
export default function BusinessArea() {
  const businessItems = [
    {
      icon: 'ri-film-line',
      title: '콘텐츠 제작',
      description: '이러닝, 홍보영상 등 고품질 제작',
      link: '/content-production'
    },
    {
      icon: 'ri-live-line',
      title: '라이브 스트리밍',
      description: '안정적인 웨비나 및 행사 중계',
      link: '/live-streaming'
    },
    {
      icon: 'ri-map-pin-line',
      title: '현장 출장',
      description: '전국 출장 및 중계 지원',
      link: '/on-site-service'
    },
    {
      icon: 'ri-building-4-line',
      title: '스튜디오 컨설팅',
      description: '설계, 시공, 운영 매뉴얼 제공',
      link: '/studio-consulting'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'AI 콘텐츠 제작',
      description: 'AI 아나운서 및 자동 자막',
      link: '/ai-content'
    },
    {
      icon: 'ri-stack-line',
      title: '통합 운영 솔루션',
      description: '연간 계약 및 품질 관리',
      link: '/integrated-solution'
    }
  ];

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section id="business" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 border-b border-gray-200 pb-4">
          <div>
            <h2 className="text-primary font-black text-4xl mb-2">Business Area</h2>
            <p className="text-gray-500">6대 핵심 비즈니스 영역</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-gray-200 shadow-xl bg-white">
          {businessItems.map((item, index) => (
            <div
              key={index}
              onClick={() => handleNavigation(item.link)}
              className="p-10 border-r border-b border-gray-200 last:border-r-0 hover:bg-gray-50 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex flex-col items-start">
                <div className="w-16 h-16 flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-5xl text-secondary group-hover:scale-110 transition-transform duration-300`}></i>
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-3 group-hover:text-secondary transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
